import Alert from "@material-ui/lab/Alert";
import { Box } from "@material-ui/core";
import DataRemover from "modus/components/misc/DataRemover";
import React from "react";
import ApiService from "../services/ApiService";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import DeleteIcon from "legacy-components/icons/DeleteIcon";

interface VersionRemoverProps {
    applicationName: string;
    applicationId: string;
    version: string;
    refreshVersions: () => void;
}

export const VersionRemover: React.FC<VersionRemoverProps> = React.memo(({
  applicationId,
  version,
  refreshVersions
}) => {

    const [state, { subscribe }] = useAsyncAction(() =>
    ApiService.deleteVersion(applicationId, version)
  );


  return (
    <>
      <DataRemover
        style={{
          border: "none",
        }}
        confirmationText={""}
        enterButtonText={undefined}
        onConfirm={subscribe}
        asyncActionState={state}
        tooltipText={"This will delete the version permanently."}
        title="Delete version"
        successMessage="Deleted version"
        onSuccess={refreshVersions}
        icon={<DeleteIcon style={{ color: "#900b09", border: "none" }}></DeleteIcon>}
        disabled={!version || version.length === 0}
        message={
          <Box>
            <Alert severity="error">
              Deleting this version terminates all active hosted regions and disconnects all integrations immediately.
            </Alert>
            <Box marginTop={"30px"}>
              This action cannot be undone. This will permanently remove
              the version and cannot be accessed elsewhere.
              <br />
            </Box>
          </Box>
        }
      />
    </>
  );
})

